import * as RadixDialog from '@radix-ui/react-dialog'
import { shellStrings as s } from '@/components/navigation/strings'
import { DsIconButton, DsIcons, DsKbd, modKeyLabel } from '@/ds'

export function ShortcutsDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const rows: [string[], string][] = [
    [[modKeyLabel(), 'K'], s.shortcutPalette],
    [['/'], s.shortcutSearch],
    [['?'], s.shortcutHelp],
    [['Esc'], s.shortcutClose],
  ]
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-50 bg-scrim animate-ds-fade-in" />
        <RadixDialog.Content className="fixed left-1/2 top-1/2 z-50 w-[min(420px,calc(100vw-32px))] -translate-x-1/2 -translate-y-1/2 rounded-2xl border bg-card p-6 shadow-lg outline-none animate-ds-scale-in">
          <div className="mb-4 flex items-center justify-between">
            <RadixDialog.Title className="font-display text-title2 text-foreground">{s.shortcuts}</RadixDialog.Title>
            <RadixDialog.Close asChild>
              <DsIconButton icon={DsIcons.close} semanticLabel={s.cancel} size="sm" />
            </RadixDialog.Close>
          </div>
          <RadixDialog.Description className="sr-only">{s.shortcuts}</RadixDialog.Description>
          <dl className="divide-y">
            {rows.map(([keys, label]) => (
              <div key={label} className="flex items-center justify-between py-2.5">
                <dt className="text-small text-foreground">{label}</dt>
                <dd className="flex gap-1">
                  {keys.map((k) => (
                    <DsKbd key={k}>{k}</DsKbd>
                  ))}
                </dd>
              </div>
            ))}
          </dl>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  )
}
